import Column from '@components/Column';
import Text from '@components/Text';
import TextField from '@components/TextField';
import colors from '@constants/colors';
import GiftOrderContext from '@providers/GiftOrderProvider/GiftOrderContext';
import { useContext } from 'react';

function Sender() {
  const { handleChange, state } = useContext(GiftOrderContext);
  return (
        <Column fullWidth spacing={12}>
            <Text color={colors.gray7} fontWeight='bold' size='2xl'>
                보내는 사람
            </Text>
            <Column fullWidth spacing={20}>
                <TextField placeholder='보내는 사람명을 입력해주세요'
                           onChange={handleChange}
                           name='userName' />
                <TextField placeholder='보내는 사람 전화번호를 입력해주세요'
                           inputMode='numeric'
                           value={state.userPhone}
                           maxLength={13}
                           onChange={handleChange}
                           name='userPhone' />
            </Column>
        </Column>
  );
}

export default Sender;
